import type { Section } from "../types";
import { doorHub } from "./products/doorHub";
import { doorHubMini } from "./products/doorHubMini";
import { elevatorHub } from "./products/elevatorHub";
import { enterpriseAccessHub } from "./products/enterpriseAccessHub";
import { gateHub } from "./products/gateHub";
import { retrofitHub } from "./products/retrofitHub";
import { uaUltra } from "./products/uaUltra";
import {
  accessPowerMethod,
  dimensions,
  inputTerminals,
  outputRelays,
  poePorts,
  powerRedundancy,
} from "./properties";

export const AccessHubs: Section = {
  properties: [
    dimensions,
    outputRelays,
    inputTerminals,
    poePorts,
    accessPowerMethod,
    powerRedundancy,
  ],
  columnWidth: 266,
  products: [
    enterpriseAccessHub,
    doorHub,
    doorHubMini,
    gateHub,
    elevatorHub,
    retrofitHub,
    uaUltra,
  ],
  propertyColumnWidth: 189,
  showBadges: true,
};
